import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingProgressBarProps {
  current: number;
  total: number;
  label?: string;
  sticky?: boolean;
  className?: string;
}

const LoadingProgressBar: React.FC<LoadingProgressBarProps> = ({
  current,
  total,
  label = "Loading...",
  sticky = false,
  className = "",
}) => {
  const safeTotal = Math.max(total, 0);
  const safeCurrent = Math.min(Math.max(current, 0), safeTotal);
  const progressPercent = safeTotal > 0 ? (safeCurrent / safeTotal) * 100 : 0;

  return (
    <div
      className={`${sticky ? "sticky top-0 z-10" : ""} bg-background/95 backdrop-blur border rounded px-2 py-1.5 ${className}`}
    >
      <div className="flex items-center justify-between text-[10px] text-muted-foreground mb-1">
        <div className="flex items-center gap-1.5">
          <Loader2 size={12} className="animate-spin" />
          <span>{label}</span>
        </div>
        <span>
          {safeCurrent}/{safeTotal}
        </span>
      </div>

      <div className="h-1.5 bg-muted rounded overflow-hidden">
        <div
          className="h-full bg-primary transition-[width] duration-150"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};

export default LoadingProgressBar;
